<template>
	<div>
		<OverviewTitleBox :title="'CAFE'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">CAFE</H6>
		</div> 
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCardComp icon="fa-chart-line" prefix="SALES" unit="M" div=1000000 :data="ytd.sales.rekap[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>
				<InfoCardComp icon="fa-plus-square" prefix="MARGIN" unit="%" :data="ytd.margin.rekap[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>
				<InfoCardComp icon="fa-chart-line" prefix="LOSSES" unit="M" div=1000000 :data="ytd.losses.rekap[1]" infocol="Info" valuecol="Value" comp=-1 url="/bright/sales"/>
			</div>
			<div class="col-md-4">
				<InfoCardComp icon="fa-store" prefix="SPD" unit="M" div=1000000 :data="ytd.sales.spd[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>
				<InfoCardComp icon="fa-chart-line" prefix="TRAFFIC" unit="" div=1 :data="ytd.basket.invoice[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>
				<InfoCardComp icon="fa-chart-line" prefix="BASKET SIZE" unit="RP" div=1 :data="ytd.basket.size[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>
				<!--
				<InfoCardComp icon="fa-box-open" prefix="TOP ITEM OOS" unit="%" :data="stock.oos.compitem" infocol="StockDate" valuecol="PctItem" comp=-1 url="/bright/stock"/>
				<InfoCardComp icon="fa-store-slash" prefix="STORE OOS" unit="" :data="stock.oos.compstore" infocol="StockDate" valuecol="CountBranch" comp=-1 url="/bright/stock"/>
				<InfoCardComp icon="fa-trash-alt" prefix="WASTE WEEK" unit="M" div=1000000 :data="weekly.compwaste" infocol="WeekNo" valuecol="Waste" comp=-1 url="/bright/sales"/>
				--> 
			</div>
			<!--
			<div class="col-md-4">
				<InfoCardComp icon="fa-truck-moving" prefix="SL SUPPLIER (LINE FILL) WEEK" unit="%" :data="weekly.compslsdline" infocol="WeekNo" valuecol="LineFillPct" comp=1 url="/bright/sl"/>
				<InfoCardComp icon="fa-truck" prefix="SL DC (LINE FILL) WEEK" unit="%" :data="weekly.compsldline" infocol="WeekNo" valuecol="LineFillPct" comp=1 url="/bright/sl"/>
			</div>
			-->
		</div>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import InfoCardComp from '@/views/pages/InfoCardComp.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'
import { Rainbow, Rainbow2, FuelColor, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'

export default {
	extends: Cafe,
	components:{
		InfoCardComp,
		OverviewTitleBox,
	},
    mounted(){
		this.loadYTD();
		//this.loadWeekly();
		//this.loadOOS();
    },
    methods:{
		async loadYTD() {
			let url = Config().apiURL + "/cafe/ytd-overview?" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				//console.log('ytd cafe: '+ JSON.stringify(result.data))
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "SalesExTax", "StoreCount", "Grup", 1, 2, false, false, "NumDay"),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.losses = {
						rekap: this.processYTD(result.data.losses, "Info", "Losses", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
				
				}
			})
		},
	}
}
</script>